<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">Manage Numberless labour charges</small>
      </legend>
      <div></div>
      <div>
        <div class="laboursLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color:blue"></i>loading labour...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemnumberlessLabours"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
        
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Labour no",
          field: "labour_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter labour number"
          }
        },
        {
          label: "Labour date",
          field: "labour_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy" // outputs Mar 16th 2018
        },
        {
          label: "Labour total",
          field: "labour_total",
          type: "text"
        },
        
      ]
    };
  },
  created() {
    this.loadnLabours();
  },
  computed: {
    ...mapGetters(["systemnumberlessLabours"])
  },
  methods: {
    ...mapActions(["loadnLabours", "editLabour"])
  }
};
</script>


// WEBPACK FOOTER //
// src/numberlesslabour/managenumberlesslabourcharges.vue